import { cloneDeep, flattenDeep, reduce } from 'lodash';
import React from 'react';
import render from 'redraft';

const convertToString = nodes =>
  reduce(
    flattenDeep(nodes),
    (result, node) => result + flattenDeep(((node || {}).props || {}).children || []).join(''),
    '',
  );

const inlineRenderers = {
  BOLD: children => children,
  ITALIC: children => children,
};

const blockRenderer = children =>
  children.map((child, index) => (
    <span key={index}>
      {child}
      {index === children.length - 1 ? null : ' '}
    </span>
  ));

const blockRenderers = {
  unstyled: blockRenderer,
  blockquote: blockRenderer,
  'header-one': blockRenderer,
  'header-two': blockRenderer,
  'unordered-list-item': blockRenderer,
  'ordered-list-item': blockRenderer,
  'code-block': blockRenderer,
};

const entityRenderers = {
  LINK: children => children,
};

export default function contentStateToString(contentState) {
  if (!contentState) {
    return '';
  }

  const contentStateCopy = cloneDeep(contentState);

  // FIXME: Redraft does not render when the first block is unstyled & empty
  const firstBlock = contentStateCopy.blocks[0];
  if (firstBlock && firstBlock.type === 'unstyled' && !firstBlock.text) {
    firstBlock.text = ' ';
  }
  return convertToString(
    render(contentStateCopy, {
      inline: inlineRenderers,
      blocks: blockRenderers,
      entities: entityRenderers,
    }),
  );
}
